/**
 * @component {"type":"Tabs","version":"1.2"}
 */

define('component-tabs',['jquery', 'knockout', 'helpers', 'training', 'user-answers'], function($, ko, helpers, Training, UserAnswers) {
    'use strict';

    return function(parentVM) {
        var self = this,
            entityVM = parentVM.entity,
            trainingVM = parentVM.training,
            fallback = function() {
                var table = document.getElementById('t-head-table');

                if (!table) {
                    setTimeout(fallback, 10);
                } else {
                    resizeTabs();

                    if (window.attachEvent) {
                        window.attachEvent('onresize', resizeTabs);
                    } else if(window.addEventListener) {
                        window.addEventListener('resize', resizeTabs, true);
                    }
                }
            },
            resizeTabs = function() {
                var tabs = document.getElementById('tabs'),
                    head = document.getElementById('t-head'),
                    table = document.getElementById('t-head-table'),
                    container = document.getElementById('tabs-container');

                if (!tabs || !head || !table) {
                    if (window.detachEvent) {
                        window.detachEvent('onresize', resizeTabs);
                    }
                    else if(window.removeEventListener) {
                        window.removeEventListener('resize', resizeTabs);
                    }
                    return;
                }

                table.style.height = 'auto';

                var tabsH = tabs.offsetHeight,
                    headH = head.offsetHeight,
                    maxH = container.offsetHeight,
                    inner = (parseInt(helpers.layout.nodeStyle(tabs, 'bottom')) || parseInt(helpers.layout.nodeStyle(tabs, 'top'))) || 0;


                if (self.maximum()) {
                    $('#t-body, .t-content').css({'height': (tabsH - headH) + 'px'});
                } else {
                    $('#t-body, .t-content').css({'max-height': (maxH - (2*inner) - headH) + 'px'});
                }

                $('#t-head-table, #t-head-table .t-shadow').css({'height': headH + 'px'});
            },
            training = new Training(),
            userAnswers = new UserAnswers();

        ko.bindingHandlers.initTabs = {
            init: function() {
                if (!Modernizr.flexbox && !Modernizr.flexboxlegacy && !Modernizr.flexboxtweener) {
                    fallback();
                }
            }
        };

        self.maximum = ko.observable(true);

        self.content = ko.computed(function() {
            var ID = entityVM.ID(),
                entity = training.getContent(ID);

            return {
                ID: ID,
                tabs: helpers.component.getContent(entity.componentsJSON, 'Tabs')
            };
        });

        self.interaction = ko.computed(function() {
            var content = self.content();

            // Backwards compatibility
            self.maximum(true);

            if (content.tabs.maximum !== undefined) {
                self.maximum(content.tabs.maximum);
            }
            // END Backwards compatibility

            if (userAnswers.isPageVisited(content.ID)) {
                return false;
            }

            return (content.tabs && content.tabs.interaction) ? true : false;
        });

        self.items = ko.computed(function() {
            var content = self.content(),
                interacted = !self.interaction(),
                arr = helpers.component.parseProp(content.tabs, 'items', 'TabItem') || [];

            for (var i = 0; i < arr.length; i++) {
                arr[i].interacted = (i === 0) ? '' : interacted.toString();
                arr[i].index = i;
                arr[i].selector = 'tab-' + i;
            }

            return arr;
        });

        self.toggle = function(o, e) {
            var target = e.currentTarget,
                head = document.querySelector('.t-nav-current'),
                prevBody = document.querySelector('.t-content-current'),
                selector = target.getAttribute('data-selector');

            if (!target || target.className.indexOf('t-nav-current') !== -1) {
                return;
            }

            target.removeAttribute('data-interacted');
            trainingVM.updateVisited();

            var body = document.getElementById(selector);

            if (head) {
                head.className = 't-nav';
            }
            target.className = target.className + ' t-nav-current';

            if (prevBody) {
                prevBody.className = 't-content';
            }
            if (body) {
                body.className = body.className + ' t-content-current';
            }

        };
    }

});

